module.exports = __webpack_public_path__ + "static/media/loading.532113fa.gif";